
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexvjqTuocr9cN1PXe2bSPD41T6WCVbdT76dSWsypjInfUMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/index.vue?macro=true";
import { default as _91id_93HAGjNmEbH3Xf3MtGor9Tk0lOAmezo_fL0rozdRLXxnYMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/news/[id].vue?macro=true";
import { default as indexfUCHS8Z14UiaoZfqalJQs_4599vpWUrGfv3JXx4ZRHa_45oMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/news/index.vue?macro=true";
import { default as indexVGGIYAb6F25nzslEhNUOJ4wTW87EKAC_na4JY1yRT84Meta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/login/index.vue?macro=true";
import { default as indexd8CD7QUKdMUr565qD3Zpsx8mtn73F_pUo8x9DqqbxRAMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/index.vue?macro=true";
import { default as _91id_933_CCuD_45X2CtnvMU3Lhwk2dWGwO7H1fxsUuLXV_aS0jsMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payouts/[id].vue?macro=true";
import { default as blockedIktC42RgWhluzGDAPUsca0tLntWbde4O8Cbs9RgtCfEMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/login/blocked.vue?macro=true";
import { default as index2f9rOACsSAKeTpX2kwsE4R6vqI3ff5juRkCWDf3DiswMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payouts/index.vue?macro=true";
import { default as indexa8JTekGGdVTS5Gi3GHihW6lo_45bY6zocl0vjwEq_45F9hsMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/profile/index.vue?macro=true";
import { default as indexifvK6Y2C8_YTJKgPxlHZKEPhviJS5oGjElmjmYkdw44Meta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payments/index.vue?macro=true";
import { default as updateYrxAIbHd0aPQXNWST6heCjvaH2M8mEbedwbAS_bXDAYMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/profile/update.vue?macro=true";
import { default as indexdjXGmcFn_Xg4mrzIOzHij15SFaf1MxfLhnGodcTi2KQMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/register/index.vue?macro=true";
import { default as form38WAIYodY6NsAHUryj3GTd0zmNLURlN5hdZgSKO3zBgMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/new/form.vue?macro=true";
import { default as indexlVSSwehGwVfgaej8DsI5I2kjJbtMSLe9kr8LnnHOU0MMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/agreements/index.vue?macro=true";
import { default as indexDNgWcRqWWHzu_450LPk5_KQJM0zMJaf3VklCgKRDnaNhIMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/new/index.vue?macro=true";
import { default as indexzIYX9ksUUDfeK3ha3xNr4s3aH1pZxj0zVMDAnA07Xu0Meta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/[id]/index.vue?macro=true";
import { default as index2X3QvYk2u_F_JsDrn3Im27O3jDRfMD1EUOmoxk3xfNoMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/login/reset/index.vue?macro=true";
import { default as reinstateZUs34jerRYQY9hYEoTL38cqAllyKU4uANaoARj6zuawMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/register/reinstate.vue?macro=true";
import { default as newB1YGBZyQYo_tOOGg4Fqmqa8672PNTR9MsjAweR7_wQwMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/tickets-support/new.vue?macro=true";
import { default as indexiwO9H0SdmUgb8mNQhlr8QSYT0i9QkQAfGZTijMlokwMMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/plans-invoices/index.vue?macro=true";
import { default as indexkjlsMlqnw2x4j3N8wA04mG5h91CjqRAoc1Edh_45kePMEMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/reset-password/index.vue?macro=true";
import { default as _91id_93Z4ytElRjm_I0UxGaeMlNLR7lWD6mJH2L3f_45PXDCsqEEMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/tickets-support/[id].vue?macro=true";
import { default as indexGWcGldNnocDWio9AdX6Mvzbv6neheg0EPiB7tD5zPE0Meta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/register/verify/index.vue?macro=true";
import { default as indexkXUjIQ00k6j67MKK6aO1TKKu4Th9LRzmTEll4tMkBhIMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/tickets-support/index.vue?macro=true";
import { default as enable_45disablezkCDTNgEgQ6M6_RM3wvKKS1nBTQ8wRuMT2epLhnyXkIMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payouts/enable-disable.vue?macro=true";
import { default as indexHLSIIO8w9hnaRJ4bUAxUjIFSETvJ_36copoHebHJ4ksMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/index.vue?macro=true";
import { default as update_45password2da8GNSGPtn7tBSu_45_4Iv9Ax212EBhwj4Qx8ZRPyQyEMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/profile/update-password.vue?macro=true";
import { default as _91tab_93KfV46wcwFy_45KZUh68zj28GCiLftC_FKGXl111ewS3PQMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/[date]/[tab].vue?macro=true";
import { default as index_46client7Qch1hloLa9XcetSPBeZ5trW_45J_451lmHEFjjAuCt2dnYMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexKVMRDZA8LuiAyjYSnmajxA9WZL96x1eWc5iUlvHOmNYMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/vehicle/index.vue?macro=true";
import { default as update_45JK13qKWvhR_XWYvVvhkRfockAKgOlVCrsbwC1jECuMMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/vehicle/update.vue?macro=true";
import { default as uploadRTCH6bi9D6j3zW7biivM3r79fBWUErVghE3QldxTap8Meta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/document/upload.vue?macro=true";
import { default as indexQHrYdhh3ZHoy_45fKbyJUPnz1LLuKLulUogZFW8Zz6hSgMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/plans-invoices/[statementId]/index.vue?macro=true";
import { default as indexle4xXh_4590GeHjChQuYOvsyvyL8ZDPh9_45qD8D6CuT3j4Meta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/[date]/bookings/[day]/index.vue?macro=true";
import { default as indexWVnf1FtiRY7w_PQ8cqr09J_45IIgCc3bUo6H75uo2sgQwMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/plans-invoices/[statementId]/[invoiceId]/index.vue?macro=true";
import { default as index2BuSSfsLFsv7mYxSXMWPnPesMwHR7gWoWDRSK3KJuoEMeta } from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/[date]/bookings/[day]/[booking]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexvjqTuocr9cN1PXe2bSPD41T6WCVbdT76dSWsypjInfUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/index.vue")
  },
  {
    name: "news-id",
    path: "/news/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/news/[id].vue")
  },
  {
    name: "news",
    path: "/news",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/news/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(indexVGGIYAb6F25nzslEhNUOJ4wTW87EKAC_na4JY1yRT84Meta || {}), ...{"middleware":["guest"]} },
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/login/index.vue")
  },
  {
    name: "insure",
    path: "/insure",
    meta: {"middleware":["auth","insure-available"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/index.vue")
  },
  {
    name: "payouts-id",
    path: "/payouts/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payouts/[id].vue")
  },
  {
    name: "login-blocked",
    path: "/login/blocked",
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/login/blocked.vue")
  },
  {
    name: "payouts",
    path: "/payouts",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payouts/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/profile/index.vue")
  },
  {
    name: "payments",
    path: "/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payments/index.vue")
  },
  {
    name: "profile-update",
    path: "/profile/update",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/profile/update.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(indexdjXGmcFn_Xg4mrzIOzHij15SFaf1MxfLhnGodcTi2KQMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/register/index.vue")
  },
  {
    name: "insure-new-form",
    path: "/insure/new/form",
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/new/form.vue")
  },
  {
    name: "agreements",
    path: "/agreements",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/agreements/index.vue")
  },
  {
    name: "insure-new",
    path: "/insure/new",
    meta: {"middleware":["auth","insure-available"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/new/index.vue")
  },
  {
    name: "insure-id",
    path: "/insure/:id()",
    meta: {"middleware":["auth","insure-available"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/insure/[id]/index.vue")
  },
  {
    name: "login-reset",
    path: "/login/reset",
    meta: { ...(index2X3QvYk2u_F_JsDrn3Im27O3jDRfMD1EUOmoxk3xfNoMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/login/reset/index.vue")
  },
  {
    name: "register-reinstate",
    path: "/register/reinstate",
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/register/reinstate.vue")
  },
  {
    name: "tickets-support-new",
    path: "/tickets-support/new",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/tickets-support/new.vue")
  },
  {
    name: "plans-invoices",
    path: "/plans-invoices",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/plans-invoices/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(indexkjlsMlqnw2x4j3N8wA04mG5h91CjqRAoc1Edh_45kePMEMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/reset-password/index.vue")
  },
  {
    name: "tickets-support-id",
    path: "/tickets-support/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/tickets-support/[id].vue")
  },
  {
    name: "register-verify",
    path: "/register/verify",
    meta: { ...(indexGWcGldNnocDWio9AdX6Mvzbv6neheg0EPiB7tD5zPE0Meta || {}), ...{"middleware":["unverified"]} },
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/register/verify/index.vue")
  },
  {
    name: "tickets-support",
    path: "/tickets-support",
    meta: { ...(indexkXUjIQ00k6j67MKK6aO1TKKu4Th9LRzmTEll4tMkBhIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/tickets-support/index.vue")
  },
  {
    name: "payouts-enable-disable",
    path: "/payouts/enable-disable",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/payouts/enable-disable.vue")
  },
  {
    name: "bookings-earnings",
    path: "/bookings-earnings",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/index.vue")
  },
  {
    name: "profile-update-password",
    path: "/profile/update-password",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/profile/update-password.vue")
  },
  {
    name: "bookings-earnings-date-tab",
    path: "/bookings-earnings/:date()/:tab()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/[date]/[tab].vue")
  },
  {
    name: "vehicle-documents",
    path: "/vehicle-documents",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/index.client.vue"))
  },
  {
    name: "vehicle-documents-vehicle",
    path: "/vehicle-documents/vehicle",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/vehicle/index.vue")
  },
  {
    name: "vehicle-documents-vehicle-update",
    path: "/vehicle-documents/vehicle/update",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/vehicle/update.vue")
  },
  {
    name: "vehicle-documents-document-upload",
    path: "/vehicle-documents/document/upload",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/vehicle-documents/document/upload.vue")
  },
  {
    name: "plans-invoices-statementId",
    path: "/plans-invoices/:statementId()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/plans-invoices/[statementId]/index.vue")
  },
  {
    name: "bookings-earnings-date-bookings-day",
    path: "/bookings-earnings/:date()/bookings/:day()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/[date]/bookings/[day]/index.vue")
  },
  {
    name: "plans-invoices-statementId-invoiceId",
    path: "/plans-invoices/:statementId()/:invoiceId()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/plans-invoices/[statementId]/[invoiceId]/index.vue")
  },
  {
    name: "bookings-earnings-date-bookings-day-booking",
    path: "/bookings-earnings/:date()/bookings/:day()/:booking()",
    component: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/pages/bookings-earnings/[date]/bookings/[day]/[booking]/index.vue")
  }
]